/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TenantSlugDiscovery = {
  slug: string;
  redirect_to: string;
  entity: TenantSlugDiscovery.entity;
};
export namespace TenantSlugDiscovery {
  export enum entity {
    COMPANY = 'company',
    FIRM = 'firm',
  }
}

